import $ from 'jquery';


export default () => {

    $('.share--button').on('click', function (e) {
        e = e || window.event;
        e.preventDefault();
        e.stopImmediatePropagation();
        $('.share--social').toggleClass('active');
        $(this).toggleClass('active');
    })

};



// WEBPACK FOOTER //
// ../views/share/share.js